module.exports = "<div class=\"dropdown-item_name\" data-value=\"{{::option.SuburbStateString}}\">\r\n    <span class=\"_optionText\" ng-bind-html=\"option.SuburbStateString | highlight:inputText\"></span>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-search-suburb-template.html
 ** module id = 1010
 ** module chunks = 1
 **/